import { useMutation } from "@tanstack/react-query";
import { businessRegistrationCertificateMutationApi } from "@/shared/api/business-registration-certificate/mutation";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

// 사업자등록증 파일 업로드 → 저장 후 OCR 파싱 결과를 받는 훅.
// 호출부가 unoFileId와 파싱 결과를 이어서 써야 하므로 mutateAsync를 노출한다.
// 파싱 실패 항목(missingRequiredFields)·경고(warnings) 판단과 성공 UI는 호출부가 담당한다.
// 조회 캐시에 넣을 데이터가 아니라 invalidateQueries는 하지 않는다.
const useParseBusinessRegistrationCertificate = () => {
  const { error } = useAppToasts({ id: "GLOBAL" });

  const { mutateAsync: parseBusinessRegistrationCertificate, isPending } =
    useMutation({
      mutationFn: (file: File) =>
        businessRegistrationCertificateMutationApi.parseBusinessRegistrationCertificate(
          file
        ),
      onError: (err) => {
        error(err);
      },
    });

  return { parseBusinessRegistrationCertificate, isPending };
};

export default useParseBusinessRegistrationCertificate;
